import { render, staticRenderFns } from "./HeaderAnnouncement.vue?vue&type=template&id=7da048f1&"
import script from "./HeaderAnnouncement.vue?vue&type=script&lang=js&"
export * from "./HeaderAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports